import {
  SCHEDULE_CATEGORIES_REQUEST,
  SCHEDULE_CATEGORIES_SUCCESS,
  SCHEDULE_CATEGORIES_FAILURE,
} from 'actions';

/**
 * Stores categories-with-athletes per competition, pre-filtered by the backend.
 *
 * State shape:
 *   isFetching: string[]   — competitionIds currently loading
 *   isFetched:  string[]   — competitionIds that have loaded successfully
 *   data:       { [competitionId]: CategoryWithStats[] }
 *
 * CategoryWithStats shape (mirrors /api/schedule/categories/{id} response):
 *   id, title, type, sex, teamCompetition, minAge, maxAge, ageCategory,
 *   athletesCount, roundCount
 */
const initialState = {
  isFetching: [],
  isFetched: [],
  data: {},
};

export const scheduleCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCHEDULE_CATEGORIES_REQUEST:
      return {
        ...state,
        isFetching: [...state.isFetching, action.competitionId],
      };

    case SCHEDULE_CATEGORIES_SUCCESS:
      return {
        isFetching: state.isFetching.filter(id => id !== action.competitionId),
        isFetched: [...state.isFetched.filter(id => id !== action.competitionId), action.competitionId],
        data: { ...state.data, [action.competitionId]: action.data },
      };

    case SCHEDULE_CATEGORIES_FAILURE:
      return {
        ...state,
        isFetching: state.isFetching.filter(id => id !== action.competitionId),
      };

    default:
      return state;
  }
};
